// @flow
// Public interface for Sparks: Called from throughout the app
export const TRACK_SPARKS_EVENT = 'sparks/TRACK_SPARKS_EVENT';
export const TRACK_EVENT = 'sparks/TRACK_EVENT';
